import { render } from "./LoadingComponent.vue?vue&type=template&id=5c2a8ed1&scoped=true&ts=true"
import script from "./LoadingComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingComponent.vue?vue&type=style&index=0&id=5c2a8ed1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2a8ed1"],['__file',"src/components/LoadingComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c2a8ed1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c2a8ed1', __exports__)) {
    api.reload('5c2a8ed1', __exports__)
  }
  
  module.hot.accept("./LoadingComponent.vue?vue&type=template&id=5c2a8ed1&scoped=true&ts=true", () => {
    api.rerender('5c2a8ed1', render)
  })

}


export default __exports__